import React from 'react';
import './components/keyframes.css';
import ArchitectureMap from './components/ArchitectureMap';
import * as graph from './graph';
import { UNCLAIMED } from './measured.generated';

export default function ArchitecturePage() {
  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0 }}>
      <ArchitectureMap
        data={{
          repo: 'Solunary',
          intro: graph.INTRO,
          groups: graph.GROUPS,
          nodes: graph.NODES,
          edges: graph.EDGES,
          flows: graph.FLOWS,
          unmapped: UNCLAIMED
        }}
      />
    </div>);

}